export * from './three-panel-page.module';
